import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { customToast, isShopifyConnected } from "../../../shared/utility";

import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import { ReactComponent as ShopifyLogo } from "../../../assets/images/shopifyLogo.svg";
import {
  buttonNameConstants,
  EMPTY_STRING,
  storeConstants,
  toastType,
} from "../../../constants";
import SimpleInputTextField from "../../../shared/components/inputTextField/SimpleInputTextField";
import { storeService } from "../../../services";
import { storeActions, systemActions } from "../../../redux/actions";
import ShopifyCustomerSyncing from "../../../shared/components/shopifyCustomerSyncing/ShopifyCustomerSyncing";

const ShopifyConnection = (props) => {
  const { currentStore, activateSpinner, deactivateSpinner } = props;
  const isConnected = isShopifyConnected(currentStore);
  const [shop, setShop] = React.useState(EMPTY_STRING);
  const handleConnectShopify = async () => {
    if (
      !shop ||
      !shop.endsWith(".myshopify.com") ||
      shop.startsWith("http://") ||
      shop.startsWith("https://")
    ) {
      customToast(
        "Please enter a valid Shopify store URL (e.g. yourstore.myshopify.com) without http:// or https://",
        toastType.ERROR
      );
      return;
    }

    activateSpinner(storeConstants.SUBSCRIBE);
    await storeService
      .connectShopify({ storeId: currentStore?.id, shop: shop })
      .then(
        (response) => {
          if (typeof response === "string" && response.startsWith("http")) {
            window.location.replace(response);
          } else {
            customToast(
              "Invalid redirect URL received from server.",
              toastType.ERROR
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      );
    deactivateSpinner(storeConstants.SUBSCRIBE);
  };

  useEffect(() => {
    if (currentStore?.id) {
      props.getUpdatedCurrentStoreDetails(currentStore?.id);
      setShop(currentStore?.shopify?.shop || EMPTY_STRING);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentStore?.id) {
      setShop(currentStore?.shopify?.shop || EMPTY_STRING);
    }
  }, [currentStore]);

  return (
    <>
      <Topbar title="Shopify Connection"></Topbar>
      <Row className=" d-flex justify-content-center align-items-center">
        <Col md={11}>
          <Col
            md={5}
            className="mx-auto d-flex flex-column gap-3 billing-card-wrapper"
          >
            <ShopifyLogo className="mx-auto" width={128} />
            <SimpleInputTextField
              name="shop"
              value={shop}
              label="Shopify Shop URL"
              wrapperClassName={"w-100"}
              isReadOnly={isConnected}
              onChange={(e) => setShop(e.target.value)}
              placeHolder="store-name.myshopify.com"
            />
            <Button
              type="button"
              className={"w-100 mt-0"}
              handleClick={handleConnectShopify}
              isDisabled={isConnected}
              label={
                isConnected
                  ? buttonNameConstants.CONNECTED
                  : buttonNameConstants.CONNECT
              }
            />
            <p className="w-100 ">
              {isConnected && (
                <>
                  This store is already connected with
                  <b> {currentStore?.shopify?.shop} </b>
                </>
              )}
              All Customers will be synced automatically, and Inventory Items
              will need to be synced selectively.
            </p>

            {isConnected && <ShopifyCustomerSyncing />}
          </Col>
        </Col>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  company: state.authentication.company,
  user: state.authentication.user,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  getUpdatedCurrentStoreDetails: (storeId) =>
    dispatch(storeActions.getUpdatedCurrentStoreDetails(storeId)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(ShopifyConnection);
